import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/fonts.scss";
import "./scss/App.scss";
import "./i18n";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { BrowserRouter } from "react-router-dom";
import "./newrelic";
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
const pathname = window.location.pathname;
const editmslConfig = msalConfig;

/*if (pathname === '/backoffice') {
  editmslConfig.auth.redirectUri = msalConfig.auth.redirectUri + pathname;
}*/

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const msalInstance = new PublicClientApplication(editmslConfig);
root.render(
  <>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </BrowserRouter>
  </>
);
//serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
